import React, { useEffect, useState } from 'react';
import {
  DarkText,
  DeleteIconBox,
  EditIconBox,
  FlexWrapper,
  FlexWrapperNoData,
  PurpleText,
  TitleContainer,
  TitleH4,
  ViewIconBox
} from '../../../theme/common_style';
import Title from 'antd/es/typography/Title';
import { Button, Table } from 'antd';
import {
  DeleteIcon,
  EditIcon,
  NoMilestone,
  TrashIconNew,
  ViewIconNew
} from '../../../theme/SvgIcons';
import ChangeRequestInfoModal from './ChangeRequestInfoModal';
import CreateRequestModal from './CreateRequestModal';
import { deleteChangeRequestApi, getChangeRequestsApi } from '../../../redux/project/apiRoute';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import { useSelector } from 'react-redux';
import { checkPermission } from '../../../utils/common_functions';
import { deleteS3Object } from '../../../utils/uploadS3Bucket';

const ChangeRequest = () => {
  const [infoModal, setInfoModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [clickedData, setClickedData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const location = useLocation();
  const { id } = location?.state || {};
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  const { isManager } = useSelector((state) => state?.projectSlice);
  let permissionSection = 'Projects';
  const canCreate = isManager || checkPermission(permissionSection, 'create', permissions);
  const canDelete = isManager || checkPermission(permissionSection, 'del', permissions);
  const canUpdate = isManager || checkPermission(permissionSection, 'update', permissions);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      title: 'Approved by client',
      dataIndex: 'client_approved',
      key: 'client_approved',
      render: (text) => (text ? 'Yes' : 'No')
    },
    {
      title: 'No of Hours',
      dataIndex: 'no_of_hours',
      key: 'no_of_hours'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text) => (
        <p
          style={{
            maxWidth: '210px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textWrap: 'nowrap'
          }}>
          {text}
        </p>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      className: 'action-column',
      render: (_, data) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'}>
            <ViewIconBox
              onClick={() => {
                setClickedData(data);
                setInfoModal(true);
              }}>
              <ViewIconNew />
            </ViewIconBox>
            {canUpdate && (
              <EditIconBox
                canUpdate={canUpdate}
                onClick={() => {
                  setClickedData(data);
                  setCreateModal(true);
                }}>
                <EditIcon />
              </EditIconBox>
            )}
            {canDelete && (
              <DeleteIconBox
                canDelete={canDelete}
                onClick={() => {
                  setDeleteModal(true);
                  setClickedData(data);
                }}>
                <DeleteIcon />
              </DeleteIconBox>
            )}
          </FlexWrapper>
        );
      }
    }
  ];

  const handleGetList = async () => {
    try {
      setLoading(true);
      let res = await getChangeRequestsApi(id);
      if (res?.statusCode === 200) {
        setTableData(res?.data || []);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      let res = await deleteChangeRequestApi(clickedData?.id);
      if (res?.statusCode === 200) {
        let paths = clickedData?.requestDocumentModule?.[0]?.document;
        if (paths) {
          await deleteS3Object(paths);
        }
        toast.success(res?.message || 'Successfully deleted');
        handleGetList();
        setDeleteModal(false);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    handleGetList();
  }, []);

  return (
    <>
      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          onCancel={() => setDeleteModal(false)}
          title={'Delete Request'}
          onSubmit={handleDelete}
          buttonName={'Delete'}
          description={'Are you sure you want to delete this request?'}
          iconBG={'#FB4A49'}
          icon={<TrashIconNew />}
          loading={deleteLoading}
        />
      )}
      <TitleContainer>
        <TitleH4>Change Request</TitleH4>
        {canCreate && (
          <PurpleText
            style={{ cursor: 'pointer', width: 'fit-content' }}
            onClick={() => {
              setCreateModal(true);
              setClickedData(null);
            }}>
            + Change Request Module
          </PurpleText>
        )}
      </TitleContainer>
      {loading || tableData.length > 0 ? (
        <Table
          prefixCls="antCustomTable"
          columns={columns}
          dataSource={tableData}
          loading={loading}
          pagination={false}
        />
      ) : (
        <FlexWrapperNoData margin="60px 20px">
          <NoMilestone />
          <Title level={5} style={{ margin: '10px 0 0' }}>
            No Change Request
          </Title>
          <DarkText weight="400">
            No change request created yet kindly create first change request
          </DarkText>
          {canCreate && (
            <Button
              prefixCls="antCustomBtn"
              style={{ margin: '16px 0' }}
              onClick={() => setCreateModal(true)}>
              + Change Request Module
            </Button>
          )}
        </FlexWrapperNoData>
      )}
      {infoModal && (
        <ChangeRequestInfoModal
          data={clickedData}
          open={infoModal}
          onCancel={() => {
            setInfoModal(false);
            setClickedData(null);
          }}
        />
      )}
      {createModal && (
        <CreateRequestModal
          open={createModal}
          onCancel={() => {
            setCreateModal(false);
          }}
          editDetails={clickedData}
          handleListing={handleGetList}
        />
      )}
    </>
  );
};

export default ChangeRequest;
